









import {Component} from 'vue-property-decorator'
import PostForm from '@/components/admin/PostForm.vue'
import PostEdit from '@/components/admin/PostEdit'
import TinyMce from '@/components/admin/TinyMce.vue'
import Post, {IPost} from '@/models/Post'
import {apiV1AdminInterviewPath} from '@/rails/routes'
import Interview, {IInterview} from '@/models/Interview'
import AddinForm from '@/components/admin/interviews/AddinForm.vue'
import {BreadCrumb} from '@/pages/page-base'

@Component({
  components: {
    AddinForm,
    TinyMce,
    PostForm
  }
})
export default class InterviewEdit extends PostEdit {

  mounted(): Promise<void> {
    this.targetPath = apiV1AdminInterviewPath(this.$route.params.id)
    return super.mounted()
  }

  toFrontModel(data: IPost): Post {
    return new Interview(data as IInterview)
  }

  get breadcrumbs(): Array<BreadCrumb> {
    return [
      {
        text: 'インタビュー一覧',
        to: '/admin/interviews',
        exact: true
      },
      {
        text: 'インタビュー編集'
      }
    ]
  }
}
